import {
  AdvancedSearchGetters,
  AdvancedSearchMutations,
  AdvancedSearchActions
} from '@/app/features/advanced-search/advanced-search.keys';
import { advancedSearchService } from '@/app/features/advanced-search/advanced-search.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { BatchUpdateListingActions } from '@/app/features/batch-update/batch-update-listing.keys';

import router from '@/router';
import i18n from '@/i18n';

export const firstLettersUpper = str => {
  let words = str.split(' ');
  words = words.map(w => w.charAt(0).toUpperCase() + w.slice(1));

  return words.join(' ');
};
export const filterFields = [
  {
    label: 'Approver Last Name',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Approver First Name',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Contractor Last Name',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Contractor First Name',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Occupation',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Branch',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'TolMultiSelect'
  },
  {
    label: 'Division',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'TolMultiSelect'
  },
  {
    label: 'Department',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'TolMultiSelect'
  },
  {
    label: 'Status',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'TolMultiSelect'
  },
  {
    label: 'Client Name',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Client Number',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Payroll Number',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Recruiter/Sales Last Name',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Recruiter/Sales First Name',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'Work Order Number',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Work Authorization',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },
  {
    label: 'Purchase Order Number',
    tables: ['time sheets', 'expenses', 'assignments'],
    component: 'InputField'
  },

  {
    label: 'Pay To Name',
    tables: ['assignments'],
    component: 'InputField'
  },
  {
    label: 'End Client Name',
    tables: ['assignments'],
    component: 'InputField'
  },

  { label: 'Containing Date', tables: ['time sheets', 'expenses'], component: 'FormDatePicker' },
  {
    label: 'Recruiter/Sales Rep Number',
    tables: ['time sheets', 'expenses', 'assignments', 'perm placements'],
    component: 'InputField'
  },
  {
    label: 'End Date is Between',
    tables: ['time sheets', 'expenses'],
    component: 'FormDatePicker'
  },
  {
    label: 'Starts Between',
    tables: ['assignments', 'perm placements'],
    component: 'FormDatePicker'
  },
  {
    label: 'Stops Between',
    tables: ['assignments'],
    component: 'FormDatePicker'
  },
  {
    label: 'Has Attachment',
    tables: ['time sheets', 'expenses'],
    component: 'ToggleSwitch'
  },
  {
    label: 'Payrollee',
    tables: ['assignments'],
    component: 'ToggleSwitch'
  },
  {
    label: 'IMAC',
    tables: ['assignments'],
    component: 'ToggleSwitch'
  },

  { label: 'Invoice Number', tables: ['perm placements'], component: 'InputField' },
  { label: 'Starts Between', tables: ['perm placements'], component: 'FormDatePicker' },
  {
    label: 'Line Of Business(IBM Only)',
    tables: ['assignments'],
    component: 'InputField'
  },
  {
    label: 'Rebate Code',
    tables: ['assignments'],
    component: 'TolMultiSelect'
  },
  {
    label: 'Entity',
    tables: ['assignments'],
    component: 'TolMultiSelect'
  },
  {
    label: 'End Date Up To',
    tables: ['time sheets', 'expenses'],
    component: 'FormDatePicker'
  }
];

export const entityList = [
  'Staff',
  'Construction',
  'Sole Proprietor',
  'Incorporation',
  'Partnership',
  'Supplier'
];

export const sortableFields = [
  'payroll number',
  'contractor name',
  'occupation',
  'client name',
  'purchase order number',
  'start date',
  'stop date',
  'end date',
  'branch name',
  'status',
  'work order number',
  'pay to name',
  'entity',
  'end client name'
];

export const tableStatuses = [
  { status: 'Draft', tables: ['time sheets', 'expense reports', 'assignments', 'perm placements'] },
  {
    status: 'Submitted',
    tables: ['time sheets', 'expense reports', 'assignments', 'perm placements']
  },
  { status: 'Approved', tables: ['time sheets', 'expense reports', 'assignments'] },
  { status: 'Processed', tables: ['time sheets', 'expense reports', 'perm placements'] },
  {
    status: 'Rejected',
    tables: ['time sheets', 'expense reports', 'assignments', 'perm placements']
  },
  {
    status: 'Obsolete',
    tables: ['time sheets', 'expense reports', 'assignments', 'perm placements']
  },
  { status: 'Cancelled', tables: ['expense reports', 'perm placements'] },
  { status: 'Expired', tables: ['time sheets', 'expense reports', 'perm placements'] },
  { status: 'Active Online', tables: ['assignments'] },
  { status: 'Active Offline', tables: ['assignments'] },
  { status: 'Finished', tables: ['assignments'] },
  { status: 'Received', tables: ['time sheets'] }
];

export const tableToRoutePrefixMap = {
  Assignments: 'assignments',
  'Time Sheets': 'time-sheets',
  'Perm Placements': 'perm-placements',
  'Expense Reports': 'expenses'
};

export const removeLeadingTrailingPluses = string => {
  if (string.charAt(0) === '+') {
    string = string.slice(1);
  }
  if (string.charAt(string.length - 1) === '+') {
    string = string.slice(0, string.length - 1);
  }

  return string;
};

/**
 * TODO
 * Add default UI search fields for Perm placements
 * 2024-07-28
 * Jira ticket: TOL4-1007
 */
export const defaultUIFields = {
  Payroll: {
    'Time Sheets': ['Branch', 'Status', 'Department', 'End Date Up To'],
    'Expense Reports': ['Status', 'End Date Up To'],
    Assignments: ['Status', 'Starts Between', 'Stops Between', 'Payrollee'],
    'Perm Placements': []
  },
  'System Admin': {
    'Time Sheets': [
      'Branch',
      'Status',
      'Department',
      'Has Attachment',
      'End Date is Between',
      'End Date Up To'
    ],
    'Expense Reports': ['Status', 'End Date is Between', 'Has Attachment'],
    Assignments: ['Status', 'Starts Between', 'Stops Between', 'Payrollee'],
    'Perm Placements': []
  },
  'Branch Admin': {
    'Time Sheets': ['Branch', 'Status', 'Department', 'End Date Up To'],
    'Expense Reports': ['Status', 'End Date Up To'],
    Assignments: ['Status', 'Starts Between', 'Stops Between', 'Payrollee'],
    'Perm Placements': []
  }
};

export const defaultResultFields = {
  Assignments: [
    'Contractor Name',
    'Client Name',
    'Payroll Number',
    'Start Date',
    'Stop Date',
    'Branch Name',
    'Status',
    'Entity'
  ],
  'Time Sheets': [
    'Contractor Name',
    'Client Name',
    'Payroll Number',
    'Start Date',
    'End Date',
    'Approvers',
    'Total Hours',
    'Department Code',
    'Has Attachment',
    'Status',
    'Entity'
  ],
  'Expense Reports': [
    'Contractor Name',
    'Client Name',
    'Payroll Number',
    'Start Date',
    'End Date',
    'Approvers',
    'Department Code',
    'Has Attachment',
    'Status',
    'Total Amount'
  ],
  'Perm Placements': [
    'First Name',
    'Last Name',
    'Branch Name',
    'Client Name',
    'Occupation',
    'Start Date'
  ]
};

export const permissionsTableMap = {
  Assignments: 'ASSIGNMENT',
  'Time Sheets': 'TIME_SHEET',
  'Expense Reports': 'EXPENSE_REPORT'
};

export const getInitialState = () => {
  return {
    selectedResults: [],
    advancedSearchFields: {
      assignmentSearchFields: [],
      timeSheetSearchFields: [],
      expenseSearchFields: [],
      permPlacementSearchFields: [],
      branches: [],
      divisions: [],
      departments: [],
      rebates: []
    },
    selectedSearchParams: {
      advancedSearchTable: '',
      advancedSearchFields: [],
      advancedSearchFilters: [
        {
          fieldName: '',
          value: ''
        }
      ]
    },
    searchResultsPaginationParams: {
      recordsPerPage: 10,
      offset: 0
    },
    searchResultsSortParameters: {
      sortBy: 'none',
      sortDirection: 'desc'
    },
    filterFields,
    sortableFields,
    tableStatuses,
    entityList,
    defaultUIFields,
    defaultResultFields,
    advancedSearchResults: [],
    searchResultsIsLoading: true,
    searchResultsRecordCount: 0,
    isBatchPdfLoading: false,
    permissionsTableMap
  };
};

export const advancedSearchStore = {
  state: getInitialState(),
  getters: {
    [AdvancedSearchGetters.IsAllSelected]: state => {
      const allRefs = state.advancedSearchResults.map(r => r.reference_number);
      return JSON.stringify(state.selectedResults) == JSON.stringify(allRefs);
    },
    [AdvancedSearchGetters.BatchPdfIsLoading]: state => {
      return state.isBatchPdfLoading;
    },
    [AdvancedSearchGetters.SelectedSearchResults]: state => {
      return state.selectedResults;
    },
    [AdvancedSearchGetters.AssignmentSearchFields]: state => {
      return state.advancedSearchFields.assignmentSearchFields;
    },
    [AdvancedSearchGetters.PermPlacementSearchFields]: state => {
      return state.advancedSearchFields.permPlacementSearchFields;
    },
    [AdvancedSearchGetters.ExpenseSearchFields]: state => {
      return state.advancedSearchFields.expenseSearchFields;
    },
    [AdvancedSearchGetters.TimeSheetSearchFields]: state => {
      return state.advancedSearchFields.timeSheetSearchFields;
    },
    [AdvancedSearchGetters.BranchNames]: state => {
      return state.advancedSearchFields.branches;
    },
    [AdvancedSearchGetters.Divisions]: state => {
      return state.advancedSearchFields.divisions;
    },
    [AdvancedSearchGetters.Departments]: state => {
      return state.advancedSearchFields.departments;
    },
    [AdvancedSearchGetters.AdvancedSearchParams]: state => {
      return state.selectedSearchParams;
    },
    [AdvancedSearchGetters.SearchResultsIsLoading]: state => {
      return state.searchResultsIsLoading;
    },
    [AdvancedSearchGetters.SearchResults]: state => {
      return state.advancedSearchResults;
    },
    [AdvancedSearchGetters.FilterFields]: state => {
      return state.filterFields;
    },
    [AdvancedSearchGetters.EntityList]: state => {
      return state.entityList;
    },
    [AdvancedSearchGetters.TableStatuses]: state => {
      return state.tableStatuses;
    },
    [AdvancedSearchGetters.SearchResultsPerPage]: state => {
      return state.searchResultsPaginationParams.recordsPerPage;
    },
    [AdvancedSearchGetters.SearchResultsOffset]: state => {
      return state.searchResultsPaginationParams.offset;
    },
    [AdvancedSearchGetters.SearchResultsRecordCount]: state => {
      return state.searchResultsRecordCount;
    },
    [AdvancedSearchGetters.SearchResultsSortField]: state => {
      return state.searchResultsSortParameters.sortBy;
    },
    [AdvancedSearchGetters.SearchResultsSortDirection]: state => {
      return state.searchResultsSortParameters.sortDirection;
    },
    [AdvancedSearchGetters.SortableFields]: state => {
      return state.sortableFields;
    },
    [AdvancedSearchGetters.Rebates]: state => {
      return state.advancedSearchFields.rebates;
    },
    [AdvancedSearchGetters.DefaultUIFields]: state => {
      return state.defaultUIFields;
    },
    [AdvancedSearchGetters.DefaultResultFields]: state => {
      return state.defaultResultFields;
    },
    [AdvancedSearchGetters.PermissionsTableMap]: state => {
      return state.permissionsTableMap;
    }
  },
  mutations: {
    [AdvancedSearchMutations.SetDefaultSearchFields]: state => {
      if (state.selectedSearchParams.advancedSearchTable !== '') {
        state.selectedSearchParams.advancedSearchFields = [
          ...state.defaultResultFields[state.selectedSearchParams.advancedSearchTable]
        ];
      }
    },
    [AdvancedSearchMutations.UpdateSelectedSearchResults]: (state, payload) => {
      const idx = state.selectedResults.findIndex(ref => ref === payload);
      let newSelected;
      if (idx >= 0) {
        newSelected = state.selectedResults.filter(ref => ref !== payload);
      } else {
        newSelected = state.selectedResults.slice();
        newSelected.push(payload);
      }
      state.selectedResults = newSelected;
    },

    [AdvancedSearchMutations.SetSearchResultsIsLoading]: (state, loading = true) => {
      state.searchResultsIsLoading = loading;
    },
    [AdvancedSearchMutations.SetBatchPdfLoading]: (state, loading = true) => {
      state.isBatchPdfLoading = loading;
    },
    [AdvancedSearchMutations.GetAdvancedSearchFields]: (state, fields) => {
      /**
       * Add fields that are required in seach results but are not
       * on the respective views
       */
      const assignmentExtraFields = [
        {
          databaseFieldName: 'ibm_line_of_business',
          searchResultField: 'ibm line of business'
        },
        {
          databaseFieldName: 'pay_rate',
          searchResultField: 'pay rate'
        },
        {
          databaseFieldName: 'bill_rate',
          searchResultField: 'bill rate'
        }
      ];
      const timeSheetExpenseExtraFields = [
        { databaseFieldName: 'approvers', searchResultField: 'approvers' },
        { databaseFieldName: 'recruiters', searchResultField: 'recruiters' },
        { databaseFieldName: 'account_managers', searchResultField: 'account managers' },
        { databaseFieldName: 'department code', searchResultField: 'department code' },
        { databaseFieldName: 'has_attachment', searchResultField: 'has attachment' },
        { databaseFieldName: 'entity', searchResultField: 'entity' }
      ];
      fields.assignmentSearchFields = fields.assignmentSearchFields
        .slice()
        .concat(assignmentExtraFields);
      fields.timeSheetSearchFields = fields.timeSheetSearchFields
        .slice()
        .concat(timeSheetExpenseExtraFields);
      fields.expenseSearchFields = fields.expenseSearchFields
        .slice()
        .concat(timeSheetExpenseExtraFields);
      state.advancedSearchFields = fields;
    },
    [AdvancedSearchMutations.SetSearchTableOrField]: (state, param) => {
      let currentTable = state.selectedSearchParams.advancedSearchTable;
      let currentSearchFields = state.selectedSearchParams.advancedSearchFields;
      let currentSearchFilters = state.selectedSearchParams.advancedSearchFilters;
      if (param.key == 'searchTable') {
        currentTable = param.value;
        currentSearchFields = [...state.defaultResultFields[currentTable]];
      } else {
        currentSearchFields.push(firstLettersUpper(param.value.field));
      }
      state.selectedSearchParams = {
        advancedSearchTable: currentTable,
        advancedSearchFields: currentSearchFields,
        advancedSearchFilters: currentSearchFilters
      };
    },
    [AdvancedSearchMutations.ClearSearchTableOrField]: (state, param) => {
      if (param.key == 'searchTable') {
        let currentTable = state.selectedSearchParams.advancedSearchTable;
        state.selectedSearchParams.advancedSearchFields = [
          ...state.defaultResultFields[currentTable]
        ];
        state.selectedSearchParams.advancedSearchFilters = [
          {
            fieldName: '',
            value: ''
          }
        ];
        state.advancedSearchResults = [];
        state.selectedSearchParams.advancedSearchTable = param.value;
      } else {
        const newFieldList = state.selectedSearchParams.advancedSearchFields.filter(
          item => item.toLowerCase() !== param.value.field
        );
        state.selectedSearchParams.advancedSearchFields = newFieldList;
      }
    },
    [AdvancedSearchMutations.SetSearchFilterField]: (state, param) => {
      const notYetSelected =
        state.selectedSearchParams.advancedSearchFilters
          .map(item => item.fieldName)
          .indexOf(param.fieldName) === -1;
      if (notYetSelected) {
        if (state.selectedSearchParams.advancedSearchFilters.length === 1) {
          state.selectedSearchParams.advancedSearchFilters[0] = param;
        } else {
          state.selectedSearchParams.advancedSearchFilters[
            state.selectedSearchParams.advancedSearchFilters.length - 1
          ] = param;
        }

        state.selectedSearchParams.advancedSearchFilters.push({
          fieldName: '',
          value: ''
        });
      }
    },
    [AdvancedSearchMutations.ClearSearchFilterField]: (state, val) => {
      let currentTable = state.selectedSearchParams.advancedSearchTable;
      let currentSearchFields = state.selectedSearchParams.advancedSearchFields.slice();
      let currentSearchFilters = state.selectedSearchParams.advancedSearchFilters.slice();

      if (currentSearchFilters.length === 1) {
        currentSearchFilters[0] = {
          fieldName: '',
          value: ''
        };
      } else {
        currentSearchFilters.splice(val, 1);
      }

      state.selectedSearchParams = {
        advancedSearchTable: currentTable,
        advancedSearchFields: currentSearchFields,
        advancedSearchFilters: currentSearchFilters
      };
    },
    [AdvancedSearchMutations.SetSearchFilterValue]: (state, param) => {
      let currentSearchFilters = state.selectedSearchParams.advancedSearchFilters.slice();

      const pos = currentSearchFilters.map(item => item.fieldName).indexOf(param.fieldName);
      if (pos >= 0) {
        currentSearchFilters[pos] = param;
      }
      state.selectedSearchParams.advancedSearchFilters = currentSearchFilters;
    },
    [AdvancedSearchMutations.SetAdvancedSearchResults]: (state, result) => {
      state.advancedSearchResults = result;
    },
    [AdvancedSearchMutations.SetSearchResultsRecordCount]: (state, count) => {
      state.searchResultsRecordCount = count;
    },
    [AdvancedSearchMutations.SetSearchPaginationParameters]: (state, params) => {
      state.searchResultsPaginationParams = params;
    },
    [AdvancedSearchMutations.SetAdvancedSearchSortOrder]: (state, sortOrder) => {
      state.searchResultsSortParameters = sortOrder;
    },
    [AdvancedSearchMutations.ResetAdvancedSearchPaginationOffset]: state => {
      state.searchResultsPaginationParams.offset = 0;
    },
    [AdvancedSearchMutations.SelectDeselectResults]: (state, isSelected) => {
      state.selectedResults = isSelected
        ? state.advancedSearchResults.map(r => r.reference_number)
        : [];
    },
    [AdvancedSearchMutations.ClearAllSelected]: state => {
      state.selectedResults = [];
    }
  },
  actions: {
    [AdvancedSearchActions.GetAdvancedSearchFields]: ({ commit }) => {
      return advancedSearchService.getAdvancedSearchFields().then(res => {
        commit(AdvancedSearchMutations.GetAdvancedSearchFields, res);
      });
    },
    [AdvancedSearchActions.SetSearchTableOrField]: ({ commit }, param) => {
      commit(AdvancedSearchMutations.SetSearchTableOrField, param);
    },
    [AdvancedSearchActions.ClearSearchTableOrField]: ({ commit }, param) => {
      commit(AdvancedSearchMutations.ClearSearchTableOrField, param);
    },
    [AdvancedSearchActions.SetSearchFilterField]: ({ commit }, param) => {
      commit(AdvancedSearchMutations.SetSearchFilterField, param);
    },
    [AdvancedSearchActions.ClearSearchFilterField]: ({ commit }, param) => {
      commit(AdvancedSearchMutations.ClearSearchFilterField, param);
    },
    [AdvancedSearchActions.SetSearchFilterValue]: ({ commit }, param) => {
      commit(AdvancedSearchMutations.SetSearchFilterValue, param);
    },
    [AdvancedSearchActions.DoAdvancedSearch]: ({ state, commit, dispatch }) => {
      commit(AdvancedSearchMutations.SetSearchResultsIsLoading);
      dispatch(AdvancedSearchActions.RetrieveSearchResultsRecordCount);
      return (
        advancedSearchService
          /**
           * TODO add pagination params to search
           * 2021-03-03
           */
          .doAdvancedSearch(
            state.selectedSearchParams,
            state.searchResultsPaginationParams,
            state.searchResultsSortParameters
          )
          .then(result => {
            commit(AdvancedSearchMutations.SetAdvancedSearchResults, result);
          })
          .then(() => {
            commit(AdvancedSearchMutations.SetSearchResultsIsLoading, false);
          })
          .catch(() => {
            commit(AdvancedSearchMutations.SetSearchResultsIsLoading, false);
            dispatch(TolErrorsActions.SetError, {
              message: 'There was an error retrieving search results'
            });
          })
      );
    },
    [AdvancedSearchActions.RetrieveSearchResultsRecordCount]: ({ state, commit }) => {
      return advancedSearchService
        .doAdvancedSearch(state.selectedSearchParams)
        .then(recordCount => {
          commit(AdvancedSearchMutations.SetSearchResultsRecordCount, recordCount);
        });
    },
    [AdvancedSearchActions.SetSearchPaginationParameters]: ({ commit, dispatch }, params) => {
      commit(AdvancedSearchMutations.SetSearchPaginationParameters, params);
      dispatch(AdvancedSearchActions.DoAdvancedSearch);
    },
    [AdvancedSearchActions.SetAdvancedSearchSortOrder]({ commit, dispatch }, sortOrder) {
      commit(AdvancedSearchMutations.SetAdvancedSearchSortOrder, sortOrder);
      commit(AdvancedSearchMutations.ResetAdvancedSearchPaginationOffset);
      dispatch(AdvancedSearchActions.DoAdvancedSearch);
    },

    [AdvancedSearchActions.ShowResultDetails]: ({ state }, param) => {
      const currentTable = state.selectedSearchParams.advancedSearchTable;

      const route = `/${tableToRoutePrefixMap[currentTable]}/${param.reference_number}`;
      if (param.reference_number) {
        router.push(route);
      }
    },
    [AdvancedSearchActions.DownloadSearchResultsAsExcel]: ({ state }, option) => {
      let pagination = { downloadAll: true };
      if (option === i18n.t('advancedSearch.actions.exportPage')) {
        pagination = state.searchResultsPaginationParams;
      }
      return advancedSearchService.downloadAdvancedSearchResults(
        state.selectedSearchParams,
        pagination,
        state.searchResultsSortParameters
      );
    },
    [AdvancedSearchActions.ToggleSelectSearchResult]({ commit }, referenceNumber) {
      commit(AdvancedSearchMutations.UpdateSelectedSearchResults, referenceNumber);
    },
    [AdvancedSearchActions.DoBatchAction]({ state, commit, dispatch }, params) {
      if (state.selectedResults.length) {
        commit(AdvancedSearchMutations.SetSearchResultsIsLoading);
        return advancedSearchService
          .doBatchAction(state.selectedResults, params)
          .then(res => {
            if (res) {
              let resArray = removeLeadingTrailingPluses(JSON.stringify(res)).split('+');
              resArray = resArray.map(r => JSON.parse(r));
              const resMessages = resArray.filter(r =>
                r && r.hasOwnProperty('message') ? true : r !== null
              );
              const batchResults = state.selectedResults.map(s => {
                if (
                  resMessages
                    .map(item =>
                      item.hasOwnProperty('message') ? item.data : item.reference_number
                    )
                    .includes(s)
                ) {
                  return {
                    reference_number: s,
                    result: resMessages.filter(i =>
                      i.hasOwnProperty('message') ? i.data === s : i.reference_number === s
                    )[0]
                  };
                } else {
                  return { reference_number: s, result: null };
                }
              });
              const searchTable = state.selectedSearchParams.advancedSearchTable;
              const route = `/${tableToRoutePrefixMap[searchTable]}/batch-update`;
              dispatch(BatchUpdateListingActions.RetrieveBatchUpdateResultList, {
                batchResults,
                advancedSearchTable: searchTable,
                advancedSearchFilters: [
                  {
                    fieldName: 'reference_number',
                    value: state.selectedResults
                  }
                ],
                advancedSearchFields: state.selectedSearchParams.advancedSearchFields,
                recordsPerPage: state.searchResultsPaginationParams.recordsPerPage,
                offset: 0
              }).then(() => {
                router.push({ path: route });
                commit(AdvancedSearchMutations.SetSearchResultsIsLoading, false);
              });
            }
          })
          .catch(err => {
            commit(AdvancedSearchMutations.SetSearchResultsIsLoading, false);
            const status = err.status;
            let message =
              status === 403
                ? i18n.t('advancedSearch.errors.notAllowed')
                : i18n.t('advancedSearch.errors.unknown', { status });
            dispatch(TolErrorsActions.SetError, { message });
          });
      }
      //clear selectedResults after each batch action
      commit(AdvancedSearchMutations.ClearAllSelected);
    },
    [AdvancedSearchActions.SelectDeselectAllResults]: ({ commit }, isSelected) => {
      commit(AdvancedSearchMutations.SelectDeselectResults, isSelected);
    },
    [AdvancedSearchActions.SetDefaultSearchFields]: ({ commit }) => {
      commit(AdvancedSearchMutations.SetDefaultSearchFields);
    },
    [AdvancedSearchActions.SetBatchPdfLoading]: ({ commit }, isLoading) => {
      commit(AdvancedSearchMutations.SetBatchPdfLoading, isLoading);
    }
  }
};
